import { useRef } from 'react';
import * as R from 'remeda';
import { Skeleton, Stack } from '@rossum/ui/material';

export const Skeletons = () => {
  const widths = useRef(
    [1, 2, 3, 4, 5].map(n => [n, R.randomInteger(100, 350)] as const)
  ).current;

  return (
    <Stack spacing={0.5}>
      {widths.map(([n, width]) => (
        <Stack key={n} direction="row" spacing={1.2}>
          <Skeleton variant="text" width={280} />
          <Skeleton variant="text" width={40} />
          <Skeleton variant="text" width={width} />
        </Stack>
      ))}
    </Stack>
  );
};
